import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        // 用户信息
        userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {},
        // 配置信息
        configs: localStorage.getItem('configs') ? JSON.parse(localStorage.getItem('configs')) : {},
        // 登录token
        token: localStorage.getItem('token') || '',
        // token过期标识
        tokenInvalidFlag: false,
    },
    mutations: {
        setUserInfo(state, userInfo) {
            state.userInfo = userInfo;
            // 将用户信息存入localStorage
            localStorage.setItem('userInfo', JSON.stringify(userInfo));
        },
        // 设置配置信息
        setConfigs(state, configs) {
            state.configs = configs;
            localStorage.setItem('configs', JSON.stringify(configs));
        },
        setToken(state, token) {
            state.token = token;
            // 将token存入localStorage
            localStorage.setItem('token', token);
        },
        logout(state) {
            state.token = '';
            state.userInfo = {};
            state.configs = {};
            // 将用户信息从localStorage中移除
            localStorage.removeItem('userInfo');
            // 将token从localStorage中移除
            localStorage.removeItem('token');
            localStorage.removeItem('configs');
        },
    },
    actions: {},
});

export default store;
